import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { WebService } from 'src/app/shared/services/web.service';
import { SecureLocalStorage } from '../../shared/services/secure-local-storage';
import { MenuItems } from '../../core/menu/menu-items/menu-items';
declare var $: any, bootbox: any;
@Component({
   selector: 'app-lockscreen',
   templateUrl: './lockscreen-component.html',
   styleUrls: ['./lockscreen-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class LockScreenComponent {
  @ViewChild('ChangepassForm') ChangepassForm: NgForm;
  ChangePass = new ChangePasswordModel();

  //oldpassword: any;
  //newpassword: any;
  //confirmpassword: any;
  Apiurl: any;
  validation: boolean = false;
  EkyClientCode: number;
  idToken: any = [];
  ClientidToken: any;
  searchLoginObj = new LoginObject();


  constructor(
    private router: Router, private webService: WebService, private secureLS: SecureLocalStorage, public menuItems: MenuItems
  ) { }

  ngOnInit() {
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
    this.idToken = this.secureLS.getStorage('RMTk');
    if (this.idToken.value.ekyc_code != null || this.idToken.value.dataset != undefined) {
      this.EkyClientCode = this.idToken.value.ekyc_code || this.idToken.value.dataset.ekycClientcode;
    } else {
      this.ClientidToken = this.secureLS.getStorage('LoginUserData');
      this.EkyClientCode = this.ClientidToken.value.ekyc_code || this.ClientidToken.value.dataset.ekycclientcode || this.ClientidToken.value.dataset.ekycClientcode;
    }
  }

  onSubmit() {
    this.router.navigate ( ['/'] );
  }

  chekpass(password) {
     
    console.log(password);

    var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (regex.exec(password) == null) {
      //bootbox.alert('invalid password!')
      return false;
    }
    else {
      console.log("valid");
      return true;
   }
  }
  ChangePassword() {
    
    if (!this.ChangepassForm.valid) {
      this.validation = true;
    }
    else
    {
      if (this.ChangePass.Newpassword && this.ChangePass.ConfirmPassword !== this.ChangePass.Newpassword)
      {
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Please Check Your Confirm Password Input, please correct and re-enter</h6></div>",
          size: 'large'
        });          
        
      }
      else
      {
        var checkpassword = this.chekpass(this.ChangePass.Newpassword);

        if (checkpassword == false)
        {
          bootbox.alert({
            message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-2'></i><br>Your password must full fill the following requirements: <br>*1 UpperCase, <br>*1LowerCase Letter, <br>*8 - 14 In Length, <br>*1 special character, <br>*1 numeric value.</h6></div>",
            size: 'large'
          });          
          return false;
        }
        else
        {
         console.log("pass", this.ChangePass.Oldpassword, this.ChangePass.Newpassword, this.ChangePass.ConfirmPassword)
         this.ChangePass.EkycClientcode = this.EkyClientCode;
		     this.Apiurl = "api/Authenticate/ChangePassword";
          
          this.webService.postData(this.Apiurl, this.ChangePass).subscribe((data: any) => {
            if (data.statusCode == "200") {
				const time_to_login = Date.now();//+ 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              bootbox.alert({
                message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>The System generated password has been changed with your new password. </h6></div>",
                size: 'large'
              });
              
              this.secureLS.setStorage('MenuList', this.menuItems.getMenuOnclient());
              this.checkClientIdentitySubmitted();
            }
            else {
              bootbox.alert(data.message);
            }
          })
        }
      }

    }
  }

  checkClientIdentitySubmitted() {
     
    var ids = this.searchLoginObj.EkycClientcode = this.EkyClientCode;
    var id = this.webService.encryptData(this.EkyClientCode)
    let url = "api/Authenticate/CheckClientIdentitySubmitted/" + id;
    this.webService.getData(url).subscribe((res: any) => {
     const time_to_login = Date.now();//+ 12 * 3600 * 1000 //15 minutes;
      this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
      if (res != null) {
        if (res.statusCode == 404) {
          this.router.navigate(['client-basic-details/pan-search']);
        }
        if (res.statusCode == 200) {
          this.router.navigate(['client-basic-details/Client-DashBord']);
        }
      }

    }, error => {

    });
  }
}   

export class ChangePasswordModel {
  EkycClientcode: number;
  Oldpassword: string;
  Newpassword: string;
  ConfirmPassword: string;
}


export class LoginObject {

  Loginname: string;
  Password: string;
  LoginOtp: number;
  EkycClientcode: number;
}


